var _title, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcBarChart = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "qrewqrqew39")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "kavabagaa17",
    x: 0,
    y: 0,
    width: 1280,
    height: 885
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.4%",
    y: "-0.5%",
    width: "100.8%",
    height: "101.1%",
    filterUnits: "objectBoundingBox",
    id: "kavabagaa2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowSpreadOuter2",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0",
    type: "matrix",
    in: "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M4.58333333,8.43333333 L7.33333333,8.43333333 L7.33333333,17.4166667 L4.58333333,17.4166667 L4.58333333,8.43333333 Z M9.71666667,4.58333333 L12.2833333,4.58333333 L12.2833333,17.4166667 L9.71666667,17.4166667 L9.71666667,4.58333333 Z M14.85,11.9166667 L17.4166667,11.9166667 L17.4166667,17.4166667 L14.85,17.4166667 L14.85,11.9166667 Z",
    id: "patheshee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "qrewqrqew",
    x: 0,
    y: 0,
    width: 45.8333333,
    height: 45.8333333
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kavabagaa8",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kavabagaa14",
    transform: "translate(-282.000000, -173.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 1440,
    height: 1024
  }), /*#__PURE__*/React.createElement("rect", {
    id: "qrewqrqew300",
    stroke: "#DFE2E5",
    fill: "#F7F8FA",
    x: -0.5,
    y: 123.5,
    width: 1441,
    height: 901
  }), /*#__PURE__*/React.createElement("g", {
    id: "qrewqrqew34",
    transform: "translate(80.000000, 139.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kavabagaa15"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#kavabagaa2)",
    xlinkHref: "#kavabagaa17"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#kavabagaa17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "kavabagaa16",
    transform: "translate(0.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "qrewqrqew39",
    transform: "translate(198.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kavabagaa10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#patheshee"
  })), /*#__PURE__*/React.createElement("use", {
    id: "kavabagaa9",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#patheshee"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kavabagaa16",
    mask: "url(#kavabagaa10)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.916667, -11.916667)",
    id: "kavabagaa12"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kavabagaa13",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qrewqrqew"
  })), /*#__PURE__*/React.createElement("use", {
    id: "kavabagaa11",
    fill: "#BEC4CA",
    xlinkHref: "#qrewqrqew"
  }))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcBarChart, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-bar-chart.da55a637.svg";
export { ForwardRef as ReactComponent };